import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Loading } from '../../common/loading'
import { Layout } from '../Layout'
import { CompanyInfo } from '../common/header/companyInfo'
import { HighlightInformation } from '../common/header/highlightInformation'
import { AssociateCompanies } from './associateCompanies'
import { Branches } from './branches'
import './lang/i18n'
import { OwnershipStructure } from './ownershipStructure'
import { ParentCompany } from './parentCompany'
import { RelatedCompany } from './relatedCompany'
import {
  keyLoading,
  resetStore,
  selectHighlights,
  selectLoading,
} from './store/slice'
import {
  getHighlights,
  getOwnershipDetail,
  getRelatedCompanyViewBy,
} from './store/thunk'
import { Subsidiaries } from './subsidiaries'
const OwnershipAndGroup = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const locale = useSelector((state) => state.i18n.locale)
  const highlights = useSelector(selectHighlights)
  const isLoadingDetail = useSelector(selectLoading(keyLoading.DETAIL))
  const isLoadingHighlight = useSelector(selectLoading(keyLoading.HIGHLIGHTS))

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const {
    parentCompanies,
    branches,
    subsidiaries,
    associates,
    relatedCompanies,
  } = highlights

  useEffect(() => {
    dispatch(
      getHighlights({
        OrganizationId: organizationId,
      }),
    )
    dispatch(
      getOwnershipDetail({
        OrganizationId: organizationId,
      }),
    )
    dispatch(
      getRelatedCompanyViewBy({
        OrganizationId: organizationId,
      }),
    )
  }, [locale, organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  const renderBottomComponent = () => {
    if (isLoadingDetail || isLoadingHighlight) {
      return <Loading />
    }

    return (
      <div className="flexColumn">
        <HighlightInformation
          highlights={[
            {
              scrollElementId: 'parentCompanies',
              detail: parentCompanies,
              title: 'companyAnalysis.ownershipAndGroup.PARENT_COMPANIES',
              isI18n: true,
            },
            {
              scrollElementId: 'branches',
              detail: branches,
              title: 'companyAnalysis.ownershipAndGroup.BRANCHES',
              isI18n: true,
            },
            {
              scrollElementId: 'subsidiaries',
              detail: subsidiaries,
              title: 'companyAnalysis.ownershipAndGroup.SUBSIDIARIES',
              isI18n: true,
            },
            {
              scrollElementId: 'associates',
              detail: associates,
              title: 'companyAnalysis.ownershipAndGroup.ASSOCIATE_COMPANIES',
              isI18n: true,
            },
            {
              scrollElementId: 'relatedCompanies',
              detail: relatedCompanies,
              title: 'companyAnalysis.ownershipAndGroup.RELATED_COMPANIES',
              isI18n: true,
            },
          ]}
        />
        {/* <RedirectConnectMap /> */}
        <OwnershipStructure organizationId={organizationId} />
        <ParentCompany organizationId={organizationId} />
        <Branches organizationId={organizationId} />
        <Subsidiaries organizationId={organizationId} />
        <AssociateCompanies organizationId={organizationId} />
        <RelatedCompany organizationId={organizationId} />
      </div>
    )
  }

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderBottomComponent={renderBottomComponent}
      isShowFooter={false}
    />
  )
}

export default OwnershipAndGroup
